import { render, staticRenderFns } from "./InfoRight.vue?vue&type=template&id=5f5dd6d3&"
import script from "./InfoRight.vue?vue&type=script&lang=js&"
export * from "./InfoRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports